module.exports = __webpack_public_path__ + "static/img/img(42).a39848f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(42).png
// module id = kL3V
// module chunks = 1